import { apiClient } from './api';
import type { ApiResponse } from '@/types';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
  };
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export async function login(payload: LoginRequest): Promise<ApiResponse<LoginResponse>> {
  return apiClient.post<LoginResponse>('/auth/login', payload);
}

export async function forgotPassword(payload: ForgotPasswordRequest): Promise<ApiResponse<{ ok: true }>> {
  return apiClient.post<{ ok: true }>('/auth/forgot-password', payload);
}

export async function resetPassword(payload: ResetPasswordRequest): Promise<ApiResponse<{ ok: true }>> {
  return apiClient.post<{ ok: true }>('/auth/reset-password', payload);
}
